import { Maybe } from 'types/FMSGraphqlTypes'
import { THeavyLoadsSchema } from '../components/HeavyLoadsModal/schema/HeavyLoadsSchema'
import { TCarrierHeavyLoadPreference } from '../types'

export const getHeavyLoadsDefaultValues = (
  heavyLoadPreference: Maybe<TCarrierHeavyLoadPreference>
): THeavyLoadsSchema => {
  const { isHeavyLoadCapable } = heavyLoadPreference || {}
  return { isHeavyLoadCapable: isHeavyLoadCapable || false }
}
